/**
 * @fileoverview PanelCard — `bp6-card` wrapper used by Multipass settings
 * pages to host a CoTable (Roles) or any other panel content. Adds the
 * Foundry padding/elevation conventions.
 *
 * Foundry mapping: `multipass-internal__panel-card.bp6-card.bp6-elevation-0`.
 */

import { Card } from "@blueprintjs/core";
import type { ReactNode } from "react";

interface PanelCardProps {
  children: ReactNode;
  className?: string;
}

export function PanelCard({ children, className }: PanelCardProps) {
  return (
    <Card data-testid="panel-card"
      elevation={0}
      className={["bp-mp-panel-card", className].filter(Boolean).join(" ")}
    >
      {children}
    </Card>
  );
}
